<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header p-2">
                  <h6 class="modal-title">
                      <template v-if="newProfile">{{$t('Add Profile')}}</template>
                      <template v-else>{{$t('Edit Profile')}}</template>
                  </h6>
                  <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
                      <span aria-hidden="true">
                          <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                          </cancel-icon>
                      </span>
                  </button>
              </div>
            <div class="modal-body">
                <div class="h-100" style="overflow:auto" ref="generalTab">
                    <div style="display:inline-flex">
                        <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;width:60%">
                            <div style="padding:4px;">
                              {{$t('Profile Image')}}
                            </div>
                            <div style="display: flex;justify-content: center;margin-top: 64px;">
                                <div class="profile-image-upload-wrapper">
                                    <div class="profile-image-display">
                                        <img v-if="imageType == 'image'" :src="getProxyConvertedURL(postData.profile_image)" style="height:100%;width:100%">
                                        <svg v-else-if="imageType == null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="height: 100% !important;width: 100% !important;color: #4e4e4e;">
                                            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                        </svg>
                                        <canvas v-else-if="imageType == 'canvas'" ref="preferenceUploadCanvas" style="border-radius:5px;" id="canvas"></canvas>
                                    </div>
                                    <div class="upload-profile-image-button">
                                        <div class="btn-wrapper">
                                        <button class="btn btn-outline-secondary" data-v-198e7d7f="">{{$t('Upload')}}</button>
                                        <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                        <input type="file"
                                            id="img-input"
                                            ref="uploadFile"
                                            @change="uploadProfileImage($event)"
                                            accept="image/*"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="common-input-field" style="margin-inline-start: 2%;margin-top:6px;">
                                <div style="height: 20px;">
                                    <label>{{$t('Name')}} *</label>
                                </div>
                                <input v-model="profileName" :placeholder="$t('Enter name')" ref="fieldProfileName" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                            </div>
                            <div class="common-input-field" style="margin-inline-start: 2%;margin-top:6px;">
                                <div style="height: 20px;">
                                    <label>{{$t('Alias')}}</label>
                                </div>
                                <input v-model="aliases" :placeholder="$t('Enter aliases')"  ref="fieldAliases" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                                <div class="config-desc mt-1">
                                    You can add multiple alias separated by comma(,)
                                </div>
                            </div>
                            <div class="common-input-field" style="margin-inline-start: 2%;margin-top:6px;">
                                <div style="height: 20px;">
                                    <label>{{$t('Nationality')}} *</label>
                                </div>
                                <input v-model="nationality" :placeholder="$t('Enter nationality')" ref="fieldNationality" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                            </div>
                            <div class="common-input-field" style="margin-inline-start: 2%;margin-top:6px;">
                                <div style="height: 20px;">
                                    <label>{{$t('State')}} *</label>
                                </div>
                                <input v-model="state" :placeholder="$t('Enter state')" ref="fieldState" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                            </div>
                            <div class="common-input-field" style="margin-inline-start: 2%;margin-top:6px;">
                                <div style="height: 20px;">
                                    <label>{{$t('Profession')}} *</label>
                                </div>
                                <input v-model="profession" :placeholder="$t('Enter profession')" ref="fieldProfession" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                            <div style="height: 20px;">
                                <label style="padding-inline-start:2px;">{{$t('Description')}} *</label>
                            </div>
                            <textarea v-model="description" :placeholder="$t('Enter description')" ref="fieldProfileDescription" type="text"  class="bg-transparent border rounded text-light input-fields w-100 desc-text-area"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-0 primary-btn-style" style="padding-inline-end:10px !important;">
              <button class="btn btn-outline-secondary" data-dismiss="modal" @click.prevent="closeDialog()">{{$t('Cancel')}}</button>
              <button class="btn btn-outline-primary" @click.prevent="updateprofileName()">
                {{$t('Save')}}
              </button>
            </div>
          </div>
        </div>
    </div>
</template>
    
    
  <script>
    import {mapActions} from "vuex";
    import CancelIcon from "../core/InlineCancelField.vue";
    import Utils from "../../components.utils.js";
    
    export default {
      props:["profileInfo", "newProfile"],
      data: () => ({
        nationality:"",
        state:"",
        description:"",
        profession:"",
        dialog: true,
        profileName:"",
        aliases:"",
        imageType:null,
        MAX_WIDTH: 320,
        MAX_HEIGHT: 180,
        MIME_TYPE: "image/jpeg",
        QUALITY: 0.7,
        uploadedImage:"",
        PROFILE_IMAGE_ALLOWED_WIDTH:128,
        originalNameValue:'',
        originalALiasValue:''
      }),
      components:{
        'cancel-icon':CancelIcon
      },
      methods:{
          closeDialog(){
              this.profileName = "";
              this.$emit("close");
          },
          uploadProfileImage(ev){
            this.imageType = "canvas";
            let file = ev.target.files[0]; // get the file
            let blobURL = URL.createObjectURL(file);
            this.drawImage(blobURL,false)
          },

        drawImage(blobURL){
            this.imageType = "canvas";
            let img = new Image();
            img.src = blobURL;
            img.onerror = ()=> {
                URL.revokeObjectURL(this.src);
                // Handle the failure properly
                alert.log("Could not able to load selected image.");
            };
            img.onload = ()=> {
                URL.revokeObjectURL(this.src);
                let wrh = img.naturalWidth / img.naturalHeight;
                let calculatedImageHeightAsPerAspectRatio = this.PROFILE_IMAGE_ALLOWED_WIDTH / wrh;
                let canvas = this.$refs.preferenceUploadCanvas;
                canvas.width = this.PROFILE_IMAGE_ALLOWED_WIDTH;
                canvas.height = calculatedImageHeightAsPerAspectRatio
                canvas.getContext("2d").drawImage(img, 0, 0, this.PROFILE_IMAGE_ALLOWED_WIDTH, calculatedImageHeightAsPerAspectRatio);
                this.$nextTick(()=>{
                    this.uploadedImage = canvas.toDataURL();
                });
            };
        },
          updateprofileName(){
            this.profileName = this.profileName.trim()
            if (this.profileName.trim().length == 0){
              alert("Please add valid name.");
              this.$refs.fieldProfileName.focus();
              return
            }
            if (this.nationality.trim().length == 0){
              alert("Please add valid nationality.");
              this.$refs.fieldNationality.focus();
              return
            }
            if (this.state.trim().length == 0){
              alert("Please add valid state.");
              this.$refs.fieldState.focus();
              return
            }
            if (this.profession.trim().length == 0){
              alert("Please add valid profession.");
              this.$refs.fieldProfession.focus();
              return
            }
            if (this.description.trim().length == 0){
              alert("Please add valid profile description.");
              this.$refs.fieldProfileDescription.focus();
              return
            }
            // Remove extra spaces and split by commas
            let profileAliases = []
            if(this.aliases.trim()){
              let pWords = this.aliases.trim().split(',');
              for(var i = 0; i < pWords.length ; i++){
                if(pWords[i].trim().length > 0 && !profileAliases.includes(pWords[i].trim())){
                  profileAliases.push(pWords[i].trim());
                }
              }
            }

            let paramsInfo = {'name':this.profileName.trim(), 'nationality':this.nationality.trim(), 'state':this.state.trim(), 'profession':this.profession.trim(), 'description':this.description.trim()};
            if(profileAliases){
              paramsInfo['alias'] = profileAliases;
            }
            if(this.newProfile){
              let payload = paramsInfo;
              if(this.uploadedImage){
                payload["profile_image"] = this.uploadedImage
              }
              this.createNewProfile(payload).then(data=>{
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.closeDialog();
                } else {
                    this.$toast.error(data.message);  
                }
              })
            }
            else{
              if (this.profileName.length != 0){
                let payload = {personalityId:this.profileInfo._id, params:paramsInfo};
                if(this.uploadedImage.trim().length > 0 && this.uploadedImage != this.profileInfo.profile_image){
                    payload.params['profile_image'] = this.uploadedImage
                }
                this.updateIndPersonalityFromServe(payload).then(data=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        let postJob = false;
                        if(this.originalNameValue.trim() != this.profileName.trim()){
                          postJob = true;
                        }
                        if(!postJob){
                          if (this.originalALiasValue.length !== profileAliases.length) {
                            postJob = true;
                          }else{
                            for (let i = 0; i < this.originalALiasValue.length; i++) {
                                if (this.originalALiasValue[i] !== profileAliases[i]) {
                                  postJob = true;
                                }
                            }
                          }
                        }
                        if(postJob){
                          this.submitJobPost(this.profileInfo._id)
                        }
                        this.closeDialog();
                    } else {
                        this.$toast.error(data.message);  
                    }
                })
              }else{
                alert("Please add valid name.")
              }
            }
          },
          submitJobPost(personalityID){
            let payload = {
                "personality_id": personalityID,
                "job_name": "Personality Update",
                "element_type": "file",
            };
            
            this.createNewJob(payload).then((data) => {
              if (data.statusCode == 200) {
                this.$toast.success(data.message);
              } else {
                this.$toast.error(data.message);
              }
            })
          },
          ...mapActions("jobs", ["createNewJob"]),
          ...mapActions("AIDataSet", ["createNewProfile","updateIndPersonalityFromServe"]),
      },
      created(){
        if(this.profileInfo){
          this.profileName = this.profileInfo.name;
          this.originalNameValue = this.profileInfo.name;
          if(this.profileInfo.alias){
            this.aliases = this.profileInfo.alias.join(',')
            this.originalALiasValue = this.profileInfo.alias;
          }
          if(this.profileInfo.profile_image){
            this.drawImage(this.profileInfo.profile_image,true)
          }
          if('nationality' in this.profileInfo){
            this.nationality = this.profileInfo.nationality;
          }
          if('state' in this.profileInfo){
            this.state = this.profileInfo.state;
          }
          if('profession' in this.profileInfo){
            this.profession = this.profileInfo.profession;
          }
          if('description' in this.profileInfo){
            this.description = this.profileInfo.description;
          }
        }  
      },
      mounted(){
        this.$refs.fieldProfileName.focus();
      }
    }
  </script>
    
  <style lang="scss" scoped>
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    .modal-dialog {
        max-width: 600px;
        width: 600px;
        margin: 0;
        padding: 0;
      }
      
      .modal-content {
        // height: 227px;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
          background: $primary-background;
          padding: 0.2rem;
        }
      }
    
    .modal {
      text-align: center;
      padding: 0!important;
      display:inline-flex !important;
      align-items: center;
      justify-content: center;
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
      margin:0px !important;
      padding: 0px !important;
    }
    .modal:before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-inline-end: -4px;
    }
    .modal-dialog {
      display: inline-block;
      text-align: start;
      vertical-align: middle;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .border{
        border: $border-color !important;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        align-items: center;
        .modal-title{
          color:$text-color;
        }
    }
     
    .primary-btn-style{
        margin-top:1%;
        button{
            height: 35px;
            width: 75px;
            font-size:14px;
        }
    }
    
    .secondary-btn-style{
      color:$text-color;
    }
    
    .key-style {
      color: $dull-text-color;
      width: 30%;
      text-align: start;
      font-size: $input-field-and-label-font-size;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    .input-fields:focus {
        outline: none;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }
    .input-fields{
      padding:6px;
      overflow:hidden;
    }
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    .config-desc{
      color: $dull-text-color;
      font-size:12px;
    }

    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 7px !important;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }
    .input-text-field{
        height: 35px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }
    .desc-text-area{
      min-height: 45px;
      max-height: 50vh;
      height: 5vh;
      resize: vertical;
    }
    .add-border{
        border: $border-color;
    }

    .profile-image-upload-wrapper{
        // padding:30px;
        .profile-image-display{
            height: auto;
            width: 130px;
            border: 1px solid #3a3a3a;
            border-radius: 10px;
            padding-top: 5px;
            margin: auto;
            .canvas{
                    height: 100%;
                    width: 100%;
                    border-radius: 5px;
            }
        }
        .upload-profile-image-button{
            padding: 8px 0px;
            margin: 0 auto;
            display: inline-block;
            .btn-wrapper{
                // margin-bottom: 8px;
                width: 170px;
                position: relative;
                margin: auto;
                display: inline-flex;
                justify-content: center;
                
                button{
                  width:77%;
                }
            }
        }
    }
    </style>